import type { CSSProperties } from "react";
import belugaBg from "@/assets/beluga-bg2.png";

export const CHAT_PRIMARY = "#5B6EF9";
export const CHAT_PRIMARY_BG = "#EDF3FF";
export const CHAT_SURFACE = "#F8FAFF";
export const CHAT_TEXT = "#1A1A1A";
export const CHAT_TEXT_MUTED = "#888888";
export const CHAT_DISABLED = "#E8E8E8";
export const CHAT_AUDIO_PLAY = "#6F7EFF";
export const CHAT_AUDIO_SLATE = "#808AA2";
export const CHAT_AUDIO_LISTEN_GRADIENT = "linear-gradient(135deg, #939BB0, #808AA2)";
export const CHAT_AUDIO_PAUSE = "#808AA2";
export const CHAT_MUTED_CORAL = "#E98585";

export const GRADIENT_TITLE_STYLE: CSSProperties = {
  background: "linear-gradient(to right, #00c6ff, #bc34f5)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  textShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
};

export const APP_PAGE_BACKGROUND_STYLE: CSSProperties = {
  backgroundColor: "#EEF3FC",
  backgroundImage: `url(${belugaBg})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export const SIDE_PANEL_CLASS =
  "hidden min-h-0 min-w-0 max-h-[calc(100dvh-2rem)] max-w-[min(40vw,28rem)] shrink-0 basis-[min(40%,28rem)] flex-col overflow-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-md sm:flex";

export const SIDE_PANEL_INNER_CLASS =
  "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-100 bg-[#F8FAFF] py-5 px-3 shadow-sm [scrollbar-gutter:stable]";
